interface SparklineProps {
  data: number[]
  width?: number
  height?: number
  trend?: 'up' | 'down' | 'flat'
}

export function Sparkline({ data, width = 48, height = 20, trend }: SparklineProps) {
  if (!data || data.length < 2) return null
  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max - min || 1
  const points = data
    .map((v, i) => {
      const x = (i / (data.length - 1)) * width
      const y = height - ((v - min) / range) * (height - 4) - 2
      return `${x},${y}`
    })
    .join(' ')
  const stroke = trend === 'up' ? '#ef4444' : trend === 'down' ? '#22c55e' : '#94a3b8'
  return (
    <svg width={width} height={height} className="inline-block align-middle">
      <polyline
        points={points}
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
